import { PriorityLevel } from './Enum';
export const priorityLevelOptions = [
    { value: PriorityLevel.Blocked, text: 'Blocked' },
    { value: PriorityLevel.Major, text: 'Major' },
    { value: PriorityLevel.Minor, text: 'Minor' }
];
export const supportedtFileExtensions = [
    '.7z',
    '.avi',
    '.bmp',
    '.csv',
    '.doc',
    '.docx',
    '.jpg',
    '.jpeg',
    '.mp4',
    '.msg',
    '.odt',
    '.pdf',
    '.png',
    '.ppt',
    '.pptx',
    '.rar',
    '.rtf',
    '.snag',
    '.svg',
    '.tif',
    '.tiff',
    '.txt',
    '.xls',
    '.xlsx',
    '.xlsm',
    '.zip'
];
